export const books = [
  {
    id: 1,
    title: "E-Commerce Mastery: Dropshipping from China",
    author: "David Chen",
    price: 29.99,
    originalPrice: 49.99,
    cover: "https://public.readdy.ai/ai/img_res/fedde37af684b85bd61b618ba040550d.jpg",
    category: "Business",
    rating: 4.8,
    sold: 3200,
  },
  {
    id: 2,
    title: "Social Media Selling: TikTok & YouTube Strategy",
    author: "Sarah Williams",
    price: 24.99,
    originalPrice: 39.99,
    cover: "https://readdy.ai/api/search-image?query=professional%20book%20cover%20about%20social%20media%20marketing%20and%20selling%2C%20modern%20vibrant%20design%2C%20red%20and%20gold%20color%20scheme%2C%20clean%20typography%2C%20white%20background%2C%20high%20quality%20book%20cover%20design&width=240&height=320&seq=book2&orientation=portrait",
    category: "Marketing",
    rating: 4.7,
    sold: 2100,
  },
  {
    id: 3,
    title: "Wholesale Buying Guide for North America",
    author: "Michael Torres",
    price: 34.99,
    originalPrice: 59.99,
    cover: "https://readdy.ai/api/search-image?query=professional%20business%20book%20cover%20about%20wholesale%20buying%20and%20importing%2C%20modern%20clean%20design%2C%20red%20and%20gold%20color%20scheme%2C%20clean%20typography%2C%20white%20background%2C%20high%20quality%20book%20cover%20design&width=240&height=320&seq=book3&orientation=portrait",
    category: "Business",
    rating: 4.9,
    sold: 4500,
  },
  {
    id: 4,
    title: "Amazon FBA: From Zero to $10K/Month",
    author: "Lisa Park",
    price: 19.99,
    originalPrice: 34.99,
    cover: "https://readdy.ai/api/search-image?query=professional%20book%20cover%20about%20amazon%20fba%20business%2C%20modern%20bold%20design%2C%20red%20and%20gold%20color%20scheme%2C%20clean%20typography%2C%20white%20background%2C%20high%20quality%20book%20cover%20design&width=240&height=320&seq=book4&orientation=portrait",
    category: "E-Commerce",
    rating: 4.6,
    sold: 1800,
  },
  {
    id: 5,
    title: "Import Export Business Blueprint",
    author: "James Anderson",
    price: 39.99,
    originalPrice: 69.99,
    cover: "https://readdy.ai/api/search-image?query=professional%20business%20book%20cover%20about%20import%20export%20trade%2C%20modern%20elegant%20design%2C%20red%20and%20gold%20color%20scheme%2C%20clean%20typography%2C%20white%20background%2C%20high%20quality%20book%20cover%20design&width=240&height=320&seq=book5&orientation=portrait",
    category: "Trade",
    rating: 4.8,
    sold: 2900,
  },

  // SAT Exam Books
  {
    id: 6,
    title: "SAT Prep 2025: Full Study Guide with 5 Practice Tests",
    author: "Princeton Review",
    price: 32.99,
    originalPrice: 54.99,
    cover: "https://readdy.ai/api/search-image?query=SAT%20exam%20preparation%20study%20guide%20book%20cover%2C%20bold%20academic%20design%2C%20navy%20blue%20and%20bright%20red%20color%20scheme%2C%20clean%20modern%20typography%2C%20white%20background%2C%20official%20test%20prep%20book%20style%2C%20high%20quality&width=240&height=320&seq=book6&orientation=portrait",
    category: "SAT Prep",
    rating: 4.9,
    sold: 8700,
  },
  {
    id: 7,
    title: "SAT Math Mastery: 1600 Score Strategy & Drills",
    author: "Kaplan Test Prep",
    price: 27.99,
    originalPrice: 44.99,
    cover: "https://readdy.ai/api/search-image?query=SAT%20math%20preparation%20book%20cover%2C%20academic%20bold%20design%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20mathematical%20symbols%2C%20clean%20typography%2C%20white%20background%2C%20standardized%20test%20prep%20book%20style%2C%20high%20quality&width=240&height=320&seq=book7&orientation=portrait",
    category: "SAT Prep",
    rating: 4.8,
    sold: 6200,
  },
  {
    id: 8,
    title: "SAT Reading & Writing: Evidence-Based Mastery",
    author: "Barron\'s Educational",
    price: 25.99,
    originalPrice: 42.99,
    cover: "https://readdy.ai/api/search-image?query=SAT%20reading%20writing%20preparation%20book%20cover%2C%20academic%20clean%20design%2C%20deep%20blue%20and%20orange%20color%20scheme%2C%20open%20book%20motif%2C%20clean%20typography%2C%20white%20background%2C%20standardized%20test%20prep%20book%20style%2C%20high%20quality&width=240&height=320&seq=book8&orientation=portrait",
    category: "SAT Prep",
    rating: 4.7,
    sold: 5100,
  },
  {
    id: 9,
    title: "Official SAT Study Guide 2025 Edition",
    author: "College Board",
    price: 22.99,
    originalPrice: 39.99,
    cover: "https://readdy.ai/api/search-image?query=official%20SAT%20college%20board%20study%20guide%20book%20cover%2C%20authoritative%20academic%20design%2C%20dark%20blue%20and%20white%20color%20scheme%2C%20college%20board%20official%20style%2C%20clean%20typography%2C%20white%20background%2C%20official%20exam%20guide%20book%2C%20high%20quality&width=240&height=320&seq=book9&orientation=portrait",
    category: "SAT Prep",
    rating: 4.9,
    sold: 12400,
  },
  {
    id: 10,
    title: "SAT Vocabulary & Word Power 2025",
    author: "McGraw-Hill Education",
    price: 18.99,
    originalPrice: 29.99,
    cover: "https://readdy.ai/api/search-image?query=SAT%20vocabulary%20word%20power%20book%20cover%2C%20academic%20vibrant%20design%2C%20purple%20and%20yellow%20color%20scheme%2C%20word%20and%20letter%20motifs%2C%20clean%20typography%2C%20white%20background%2C%20vocabulary%20study%20book%20style%2C%20high%20quality&width=240&height=320&seq=book10&orientation=portrait",
    category: "SAT Prep",
    rating: 4.6,
    sold: 4300,
  },

  // Famous University Books — Batch 1
  {
    id: 11,
    title: "Harvard Business Review: On Strategy & Leadership",
    author: "Harvard Business School Press",
    price: 44.99,
    originalPrice: 74.99,
    cover: "https://readdy.ai/api/search-image?query=Harvard%20Business%20Review%20book%20cover%2C%20prestigious%20academic%20design%2C%20deep%20crimson%20red%20and%20white%20color%20scheme%2C%20Harvard%20shield%20emblem%20style%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20elite%20university%20publication%2C%20high%20quality&width=240&height=320&seq=book11&orientation=portrait",
    category: "Harvard",
    rating: 4.9,
    sold: 15600,
  },
  {
    id: 12,
    title: "Harvard Negotiation Project: Getting to Yes",
    author: "Roger Fisher — Harvard Law",
    price: 19.99,
    originalPrice: 32.99,
    cover: "https://readdy.ai/api/search-image?query=Harvard%20negotiation%20getting%20to%20yes%20book%20cover%2C%20prestigious%20academic%20design%2C%20crimson%20red%20and%20gold%20color%20scheme%2C%20handshake%20motif%2C%20elegant%20typography%2C%20white%20background%2C%20Harvard%20Law%20School%20publication%20style%2C%20high%20quality&width=240&height=320&seq=book12&orientation=portrait",
    category: "Harvard",
    rating: 4.9,
    sold: 22000,
  },
  {
    id: 13,
    title: "MIT Entrepreneurship: Innovation & Startup Playbook",
    author: "MIT Sloan School of Management",
    price: 49.99,
    originalPrice: 84.99,
    cover: "https://readdy.ai/api/search-image?query=MIT%20entrepreneurship%20innovation%20startup%20book%20cover%2C%20prestigious%20academic%20design%2C%20dark%20gray%20and%20bright%20red%20color%20scheme%2C%20technology%20circuit%20motif%2C%20modern%20clean%20typography%2C%20white%20background%2C%20MIT%20university%20publication%20style%2C%20high%20quality&width=240&height=320&seq=book13&orientation=portrait",
    category: "MIT",
    rating: 4.8,
    sold: 9800,
  },
  {
    id: 14,
    title: "Yale School of Management: Finance & Investment Principles",
    author: "Yale School of Management",
    price: 54.99,
    originalPrice: 89.99,
    cover: "https://readdy.ai/api/search-image?query=Yale%20university%20finance%20investment%20book%20cover%2C%20prestigious%20academic%20design%2C%20dark%20navy%20blue%20and%20white%20color%20scheme%2C%20Yale%20bulldog%20emblem%20style%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20elite%20university%20finance%20publication%2C%20high%20quality&width=240&height=320&seq=book14&orientation=portrait",
    category: "Yale",
    rating: 4.8,
    sold: 7200,
  },
  {
    id: 15,
    title: "Stanford Design Thinking: Innovation for Business",
    author: "Stanford d.school",
    price: 47.99,
    originalPrice: 79.99,
    cover: "https://readdy.ai/api/search-image?query=Stanford%20design%20thinking%20innovation%20book%20cover%2C%20prestigious%20academic%20design%2C%20cardinal%20red%20and%20white%20color%20scheme%2C%20creative%20design%20motif%2C%20modern%20clean%20typography%2C%20white%20background%2C%20Stanford%20university%20publication%20style%2C%20high%20quality&width=240&height=320&seq=book15&orientation=portrait",
    category: "Stanford",
    rating: 4.9,
    sold: 11300,
  },
  {
    id: 16,
    title: "Oxford Economics: Global Trade & Market Analysis",
    author: "Oxford University Press",
    price: 59.99,
    originalPrice: 99.99,
    cover: "https://readdy.ai/api/search-image?query=Oxford%20University%20Press%20economics%20global%20trade%20book%20cover%2C%20prestigious%20academic%20design%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20Oxford%20coat%20of%20arms%20style%2C%20classic%20serif%20typography%2C%20white%20background%2C%20elite%20British%20university%20publication%2C%20high%20quality&width=240&height=320&seq=book16&orientation=portrait",
    category: "Oxford",
    rating: 4.7,
    sold: 6800,
  },
  {
    id: 17,
    title: "Columbia Business School: Marketing in the Digital Age",
    author: "Columbia University Press",
    price: 42.99,
    originalPrice: 69.99,
    cover: "https://readdy.ai/api/search-image?query=Columbia%20University%20business%20marketing%20digital%20age%20book%20cover%2C%20prestigious%20academic%20design%2C%20light%20blue%20and%20white%20color%20scheme%2C%20Columbia%20crown%20logo%20style%2C%20modern%20typography%2C%20white%20background%2C%20Ivy%20League%20university%20publication%2C%20high%20quality&width=240&height=320&seq=book17&orientation=portrait",
    category: "Columbia",
    rating: 4.7,
    sold: 5400,
  },
  {
    id: 18,
    title: "Wharton School: The Art of Value Investing",
    author: "Wharton School of Business — UPenn",
    price: 52.99,
    originalPrice: 87.99,
    cover: "https://readdy.ai/api/search-image?query=Wharton%20School%20University%20of%20Pennsylvania%20value%20investing%20book%20cover%2C%20prestigious%20academic%20design%2C%20dark%20blue%20and%20red%20color%20scheme%2C%20financial%20charts%20motif%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20top%20business%20school%20publication%2C%20high%20quality&width=240&height=320&seq=book18&orientation=portrait",
    category: "Wharton",
    rating: 4.8,
    sold: 8100,
  },
  {
    id: 19,
    title: "Chicago Booth: Behavioral Economics & Decision Making",
    author: "University of Chicago Booth School",
    price: 46.99,
    originalPrice: 77.99,
    cover: "https://readdy.ai/api/search-image?query=University%20of%20Chicago%20Booth%20behavioral%20economics%20book%20cover%2C%20prestigious%20academic%20design%2C%20maroon%20and%20gray%20color%20scheme%2C%20brain%20and%20decision%20motif%2C%20clean%20modern%20typography%2C%20white%20background%2C%20top%20business%20school%20publication%2C%20high%20quality&width=240&height=320&seq=book19&orientation=portrait",
    category: "Chicago",
    rating: 4.8,
    sold: 6600,
  },
  {
    id: 20,
    title: "Princeton Review: Complete Guide to Top US Universities",
    author: "Princeton Review Editorial Team",
    price: 29.99,
    originalPrice: 49.99,
    cover: "https://readdy.ai/api/search-image?query=Princeton%20university%20complete%20guide%20top%20universities%20book%20cover%2C%20prestigious%20academic%20design%2C%20orange%20and%20black%20color%20scheme%2C%20university%20campus%20motif%2C%20clean%20modern%20typography%2C%20white%20background%2C%20college%20admissions%20guide%20book%2C%20high%20quality&width=240&height=320&seq=book20&orientation=portrait",
    category: "Princeton",
    rating: 4.9,
    sold: 18900,
  },

  // Famous University Books — Batch 2 (Harvard, Yale, Cambridge, Oxford)
  {
    id: 21,
    title: "Harvard Medical School Guide: Mind, Body & Longevity",
    author: "Harvard Medical School",
    price: 38.99,
    originalPrice: 64.99,
    cover: "https://readdy.ai/api/search-image?query=Harvard%20Medical%20School%20health%20longevity%20wellness%20book%20cover%2C%20prestigious%20academic%20design%2C%20deep%20crimson%20red%20and%20clean%20white%20color%20scheme%2C%20medical%20emblem%20motif%2C%20refined%20serif%20typography%2C%20white%20background%2C%20Harvard%20university%20health%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book21&orientation=portrait",
    category: "Harvard",
    rating: 4.9,
    sold: 19200,
  },
  {
    id: 22,
    title: "Harvard Law Review: Justice, Rights & Modern Society",
    author: "Harvard Law School Press",
    price: 56.99,
    originalPrice: 94.99,
    cover: "https://readdy.ai/api/search-image?query=Harvard%20Law%20Review%20justice%20rights%20society%20book%20cover%2C%20prestigious%20academic%20design%2C%20deep%20crimson%20and%20gold%20color%20scheme%2C%20scales%20of%20justice%20emblem%2C%20classic%20serif%20typography%2C%20white%20background%2C%20Harvard%20Law%20School%20prestigious%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book22&orientation=portrait",
    category: "Harvard",
    rating: 4.8,
    sold: 11400,
  },
  {
    id: 23,
    title: "Harvard Kennedy School: Leadership in Public Policy",
    author: "Harvard Kennedy School of Government",
    price: 51.99,
    originalPrice: 86.99,
    cover: "https://readdy.ai/api/search-image?query=Harvard%20Kennedy%20School%20public%20policy%20leadership%20government%20book%20cover%2C%20prestigious%20academic%20design%2C%20crimson%20red%20and%20silver%20color%20scheme%2C%20government%20building%20motif%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20Harvard%20university%20government%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book23&orientation=portrait",
    category: "Harvard",
    rating: 4.7,
    sold: 8300,
  },
  {
    id: 24,
    title: "Yale Law Journal: Constitutional Law & Civil Liberties",
    author: "Yale Law School",
    price: 58.99,
    originalPrice: 97.99,
    cover: "https://readdy.ai/api/search-image?query=Yale%20Law%20Journal%20constitutional%20law%20civil%20liberties%20book%20cover%2C%20prestigious%20academic%20design%2C%20dark%20navy%20blue%20and%20gold%20color%20scheme%2C%20law%20scales%20and%20Yale%20crest%20emblem%2C%20classic%20serif%20typography%2C%20white%20background%2C%20Yale%20Law%20School%20prestigious%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book24&orientation=portrait",
    category: "Yale",
    rating: 4.8,
    sold: 7600,
  },
  {
    id: 25,
    title: "Yale School of Public Health: Global Health & Epidemiology",
    author: "Yale School of Public Health",
    price: 49.99,
    originalPrice: 82.99,
    cover: "https://readdy.ai/api/search-image?query=Yale%20School%20of%20Public%20Health%20global%20health%20epidemiology%20book%20cover%2C%20prestigious%20academic%20design%2C%20navy%20blue%20and%20forest%20green%20color%20scheme%2C%20world%20globe%20health%20motif%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20Yale%20university%20health%20science%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book25&orientation=portrait",
    category: "Yale",
    rating: 4.7,
    sold: 6100,
  },
  {
    id: 26,
    title: "Cambridge University Press: Economics of Innovation",
    author: "Cambridge University Press",
    price: 62.99,
    originalPrice: 104.99,
    cover: "https://readdy.ai/api/search-image?query=Cambridge%20University%20Press%20economics%20innovation%20book%20cover%2C%20prestigious%20British%20academic%20design%2C%20deep%20royal%20blue%20and%20gold%20color%20scheme%2C%20Cambridge%20coat%20of%20arms%20emblem%2C%20classic%20refined%20serif%20typography%2C%20white%20background%2C%20elite%20Cambridge%20university%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book26&orientation=portrait",
    category: "Cambridge",
    rating: 4.9,
    sold: 13700,
  },
  {
    id: 27,
    title: "Cambridge Business English: Advanced Communication & Negotiation",
    author: "Cambridge University Press",
    price: 34.99,
    originalPrice: 57.99,
    cover: "https://readdy.ai/api/search-image?query=Cambridge%20Business%20English%20advanced%20communication%20negotiation%20book%20cover%2C%20prestigious%20British%20academic%20design%2C%20royal%20blue%20and%20white%20color%20scheme%2C%20Cambridge%20bridge%20river%20motif%2C%20clean%20modern%20serif%20typography%2C%20white%20background%2C%20Cambridge%20university%20language%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book27&orientation=portrait",
    category: "Cambridge",
    rating: 4.8,
    sold: 21500,
  },
  {
    id: 28,
    title: "Cambridge Handbook of Strategy & Competitive Advantage",
    author: "Cambridge Judge Business School",
    price: 67.99,
    originalPrice: 112.99,
    cover: "https://readdy.ai/api/search-image?query=Cambridge%20Judge%20Business%20School%20strategy%20competitive%20advantage%20handbook%20book%20cover%2C%20prestigious%20British%20academic%20design%2C%20deep%20navy%20and%20gold%20color%20scheme%2C%20chess%20strategy%20motif%2C%20refined%20serif%20typography%2C%20white%20background%2C%20Cambridge%20business%20school%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book28&orientation=portrait",
    category: "Cambridge",
    rating: 4.9,
    sold: 9400,
  },
  {
    id: 29,
    title: "Oxford Handbook of International Business & Trade Law",
    author: "Oxford University Press",
    price: 72.99,
    originalPrice: 119.99,
    cover: "https://readdy.ai/api/search-image?query=Oxford%20Handbook%20international%20business%20trade%20law%20book%20cover%2C%20prestigious%20British%20academic%20design%2C%20dark%20navy%20blue%20and%20gold%20color%20scheme%2C%20Oxford%20Bodleian%20library%20motif%2C%20classic%20authoritative%20serif%20typography%2C%20white%20background%2C%20Oxford%20University%20Press%20prestigious%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book29&orientation=portrait",
    category: "Oxford",
    rating: 4.8,
    sold: 8900,
  },
  {
    id: 30,
    title: "Oxford Said Business School: Entrepreneurship & Venture Capital",
    author: "Oxford Said Business School",
    price: 54.99,
    originalPrice: 91.99,
    cover: "https://readdy.ai/api/search-image?query=Oxford%20Said%20Business%20School%20entrepreneurship%20venture%20capital%20book%20cover%2C%20prestigious%20British%20academic%20design%2C%20deep%20blue%20and%20warm%20gold%20color%20scheme%2C%20Oxford%20spires%20skyline%20motif%2C%20elegant%20serif%20typography%2C%20white%20background%2C%20Oxford%20university%20business%20publication%2C%20high%20quality%20professional%20book&width=240&height=320&seq=book30&orientation=portrait",
    category: "Oxford",
    rating: 4.7,
    sold: 7300,
  },
];
